/**
 * What a click on a piece of text is, for the app-wide quick-actions card (ContractQuickActions).
 *
 * Every contract-number format in use: B2609000D04477611, I2205D03285795 (older, short year
 * block) and C2511ARE759740 (leasing). One letter, 4-7 digits, 1-3 letters, 6-8 digits.
 *
 * Customer IDs (26 Sep 2026 audit, CON-14): spaces and dashes used to be stripped from ANY text
 * before looking for a 10-digit id, so a date-time "2026-09-12 14:33" became "2026091214:33" and
 * opened "Open customer in Ejar" for 2026091214 - and so did any 10-digit ticket or booking number.
 * Now an Emirates ID (784 + 12 digits, dashes allowed only in its own groups) is found anywhere;
 * a 10-digit Saudi id / iqama only where the page tagged the value as a Customer ID
 * (data-quick-kind="identity", e.g. <CellId quickKind="identity">).
 */
const CONTRACT_RE = /\b([A-Z]\d{4,7}[A-Z]{1,3}\d{6,8})\b/;
const EMIRATES_ID_RE = /(?:^|[^\d-])(784-?\d{4}-?\d{7}-?\d)(?![\d-])/;
const SAUDI_ID_RE = /^[12]\d{9}$/;

export const matchNumber = (txt, { identityTag = false } = {}) => {
    const t = (txt || '').trim();
    if (!t || t.length > 40) return null;
    const c = t.match(CONTRACT_RE);
    if (c) return { kind: 'contract', value: c[1] };
    const e = t.match(EMIRATES_ID_RE);
    if (e) return { kind: 'identity', value: e[1].replace(/-/g, '') };
    if (identityTag) {
        const d = t.replace(/[\s-]/g, '');
        if (SAUDI_ID_RE.test(d)) return { kind: 'identity', value: d };
    }
    return null;
};

export default matchNumber;
